import { Grid } from "@mui/material";
import { Link } from "#common/Link";
import { generatePath } from "react-router";
import { Routes } from "#/config";
import { OperatorInvocationProgress } from "#components/Model/OperatorInvocation/OperatorInvocationProgress";
import React from "react";

export const OperatorInvocationsListing = ({ ops }: { ops: number[] }) => (
    <Grid container spacing={4}>
        {ops.map(id => (
            <Grid item key={id} xs={4}>
                <Link
                    to={generatePath(Routes.operatorInvocation.path, {
                        id: String(id),
                    })}
                >
                    <OperatorInvocationProgress id={id} />
                </Link>
            </Grid>
        ))}
    </Grid>
);
